define([
    'jquery',
], function($) {
    'use strict';

    var init = function() {
        $(document).on('mouseenter', '.nav_main__wrap', function() {
            $('.nav_main__wrap').addClass('mouseenter');
        });

        $(document).on('mouseleave', '.nav_main__wrap', function() {
            $('.nav_main__wrap').removeClass('mouseenter');
        });
    };

    return {
        init: init
    };
});
